exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".member-approve-popups .el-form-item {\n  margin-bottom: 0;\n}\n.member-approve-popups .el-form-item .el-form-item__label {\n    color: #333333;\n    font-weight: 700;\n}\n.member-form-popups .member-form__wrap {\n  padding: 0 20px;\n  height: 400px;\n  overflow: auto;\n}\n.member-form-popups .el-dialog__footer {\n  border-top: 1px solid #DCDFE6;\n}\n.member-form-popups .el-dialog__body {\n  padding: 10px 10px 0;\n}\n.member-form-popups .el-dialog__body .el-input .el-select .el-input {\n    width: 80px;\n}\n", ""]);

// exports
